import controller from './collabora-online.controller';
import template from './collabora-online.html';
import './collabora-online.scss';

export default {
	template,
	bindings:     {
		form:     '<?',
		node:     '<',
		change:   '&?ngChange',
		disabled: '<?ngDisabled',
		file:     '<?ngModel',
	},
	controller,
	controllerAs: '$ctrl',
	require:      {
		kformCtrl:   '^^?kform',
		ngModelCtrl: 'ngModel',
	},
};
